import { redux_store } from "../../../store";
import { objectToQueryString } from "../../../helpers/objectToQueryString";
import { DEFAULTS, API } from "../../api";
async function address_list(query) {
    const state = redux_store.getState();
    const userState = state.userState;
    const url = process.env.LETS_TRADE_USER_URL ?? "";
    return await new API().apiGet({
        baseUrl: url,
        endpoint: `v2/address/list${objectToQueryString({ page: DEFAULTS.PAGE, size: DEFAULTS.SIZE, ...query })}`, //
        authorization: userState.user.token,
    });
}
export { address_list };
